import Button from '@mui/joy/Button'
import Lock from '@mui/icons-material/Lock'

export const LockButton = ({ onClick }) => (
    <Button
        variant="soft"
        color="neutral"
        onClick={onClick}
        startDecorator={<Lock />}
    >
        Lock
    </Button>
)
